var _style, _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFire(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 110 30",
    style: {
      enableBackground: "new 0 0 110 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{enable-background:new    ;}\r\n\t.st1{fill:#F8A54F;}\r\n\t.st2{fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 110,
    height: 30
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    transform: "translate(15 15)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Tag_Fire",
    transform: "translate(10 10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4_1_",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -15, -15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-2",
    className: "st1",
    d: "M15,0h80c8.3,0,15,6.7,15,15l0,0c0,8.3-6.7,15-15,15H15C6.7,30,0,23.3,0,15l0,0 C0,6.7,6.7,0,15,0z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    className: "st2",
    d: "M1.8,7c-1.5,0-3-0.6-4-1.7c-1.3-1.3-1.8-3.1-1.6-4.9C-3.7-0.6-3.4-1.4-3-2.2 c-0.1,0.3-0.1,0.6-0.1,0.9c0,0.3,0.1,0.6,0.2,0.8c0,0,0,0,0,0c0.4-0.8,0.8-1.5,1.3-2.2C-1-3.3-0.4-3.8,0.2-4.3 C0.6-4.5,1-4.8,1.3-5.1c1.3-1.4,0.5-4.1,0.5-4.1l0,0c0,0,0,0,0,0c0.9,0.8,1.5,1.8,1.9,3c0.1,0.7,0.1,1.4,0,2 C3.6-3.5,3.5-2.9,3.8-2.6c0.2,0.2,0.4,0.2,0.6,0.2h0.1c0.3,0,0.6-0.1,0.7-0.4c0.4-0.7-0.5-2.3-0.5-2.4l0,0c0,0,0,0,0,0 c0.7,0.4,1.3,0.9,1.9,1.5c1.1,1.1,1.8,2.6,1.7,4.2C8.2,2,7.4,3.3,6.1,4c-0.6,0.4-1.3,0.7-2,0.9c0.5-0.4,0.9-1,1.2-1.6 c0.1-0.8,0-1.5-0.2-2.2c0,0,0,0,0,0C5,1.7,4.7,2.2,4.4,2.7C4,3.2,3.5,3.4,2.9,3.5C3.4,3.2,3.8,2.6,3.8,2c0-0.9-0.8-1.6-1.7-1.6 C1.3,0.4,0.5,1.1,0.5,2c0,0.2,0.1,0.5,0.2,0.7C0.3,2.4,0.1,2,0,1.5c0,0-0.6,2.6,1.1,3.9C1.8,5.8,2.7,6,3.5,6c1,0,1.9-0.2,2.8-0.4 c0,0,0,0,0,0C4.9,6.4,3.4,6.9,1.8,7z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M50.7,16.2h-3.9v4.1h-2.1v-10h6.5V12h-4.4v2.6h3.9V16.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M54.6,20.3h-2.1v-10h2.1V20.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M60.2,16.7h-1.6v3.6h-2.1v-10h3.7c1.2,0,2.1,0.3,2.7,0.8s1,1.3,1,2.2c0,0.7-0.1,1.2-0.4,1.7 c-0.3,0.5-0.7,0.8-1.3,1.1l2.2,4.1v0.1H62L60.2,16.7z M58.5,15h1.7c0.5,0,0.9-0.1,1.2-0.4s0.4-0.6,0.4-1.1c0-0.5-0.1-0.8-0.4-1.1 c-0.3-0.3-0.7-0.4-1.2-0.4h-1.6V15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M71.4,16h-3.9v2.7h4.6v1.6h-6.7v-10h6.7V12h-4.6v2.4h3.9V16z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.77f030474e5691481c4d519e7d5bc169.svg";
export { ForwardRef as ReactComponent };